module.exports = __webpack_public_path__ + "img/blender.7ddc4fd7.png";